import axios from "axios";

// ================================
// BASE URL
// ================================

let APL_LINK = "http://192.168.1.69:8000/";
APL_LINK = "https://backendpython.advancecollisionrepair.com/";

let Website_URL = "https://www.advancecollisionrepair.com/";
// ================================
// WEBSITE API
// ================================

let version_vi_api_website = APL_LINK + "api/v1/Website/";

// Website APIs
const get_blog_data_website = version_vi_api_website + "get_blog_data_website";

const save_contact_estimate = version_vi_api_website + "save_contact_estimate";

const get_home_page_data = version_vi_api_website + "get_home_page_data";

const get_faq_by_page = version_vi_api_website + "get_faq_by_page";

const blog_details_website = version_vi_api_website + "blog_details_website";

const get_seo_data_website = version_vi_api_website + "get_seo_data_website";

const get_seo_by_url = version_vi_api_website + "get_seo_by_url";

const get_blog_data_website_by_url =
  version_vi_api_website + "get_blog_data_website_by_url";

const get_website_contact_data =
  version_vi_api_website + "get_website_contact_data";

const save_subs = version_vi_api_website + "save_subs";

// ================================
// ADMIN API
// ================================

let version_vi_api_admin = APL_LINK + "api/v1/admin/";

// Admin Auth
const login_to_superadmin = version_vi_api_admin + "login_to_superadmin";

// Dashboard
const get_dashboard_overview = version_vi_api_admin + "get_dashboard_overview";

// Blog APIs
const save_update_blog = version_vi_api_admin + "save_update_blog";

const get_all_blogs = version_vi_api_admin + "get_all_blogs";

const save_blog_keyword = version_vi_api_admin + "save_blog_keyword";

const get_all_blog_keyword = version_vi_api_admin + "get_all_blog_keyword";

// SEO APIs
const save_update_seo = version_vi_api_admin + "save_update_seo";

const get_all_seo = version_vi_api_admin + "get_all_seo";

// Image APIs
const get_all_imagelink = version_vi_api_admin + "get_all_imagelink";

const save_update_imagelink = version_vi_api_admin + "save_update_imagelink";

// Subscribe APIs
const get_all_subscribe = version_vi_api_admin + "get_all_subscribe";

const save_subscribe = version_vi_api_admin + "save_subscribe";

// Staff APIs
const save_update_staff = version_vi_api_admin + "save_update_staff";

const get_all_staff = version_vi_api_admin + "get_all_staff";

// Staff Rights APIs
const save_update_StaffRights =
  version_vi_api_admin + "save_update_StaffRights";

const get_all_staffRights = version_vi_api_admin + "get_all_staffRights";

const action_update_staff_right =
  version_vi_api_admin + "action_update_staff_right";

// Designation APIs
const get_all_designation = version_vi_api_admin + "get_all_designation";

const save_update_designtion = version_vi_api_admin + "save_update_designtion";

// Contact APIs
const save_contact_admin = version_vi_api_admin + "save_contact_admin";

// Testimonials APIs
const save_update_testimonials =
  version_vi_api_admin + "save_update_testimonials";

const get_all_testimonials = version_vi_api_admin + "get_all_testimonials";

const delete_testimonials = version_vi_api_admin + "delete_testimonials";
const save_update_WebsiteManagement =
  version_vi_api_admin + "save_update_WebsiteManagement";
const get_all_WebsiteManagement =
  version_vi_api_admin + "get_all_WebsiteManagement";
const delete_website_master_data =
  version_vi_api_admin + "delete_website_master_data";
const save_update_blogfaq = version_vi_api_admin + "save_update_blogfaq";
const get_all_blogfaq = version_vi_api_admin + "get_all_blogfaq";
const get_all_contact = version_vi_api_admin + "get_all_contact";
const save_update_blog_category =
  version_vi_api_admin + "save_update_blog_category";
const get_all_blog_category = version_vi_api_admin + "get_all_blog_category";
const toggle_blog_category = version_vi_api_admin + "toggle_blog_category";
const delete_blog_category = version_vi_api_admin + "delete_blog_category";
const get_service_gallery_admin = version_vi_api_admin + "get_service_gallery_admin";
const save_update_service_gallery = version_vi_api_admin + "save_update_service_gallery";
const delete_service_gallery = version_vi_api_admin + "delete_service_gallery";


// ================================
// COMMON API POST FUNCTION
// ================================

const server_post_data = async (url_for, form_data) => {
  try {
    if (form_data === null) {
      form_data = new FormData();
    }

    const response = await axios.post(url_for, form_data);

    return response;
  } catch (error) {
    throw error;
  }
};

// ================================
// STATIC DATA
// ================================

const MOBILE_NO = "(847) 250-7280";
const MOBILE_NO_CALL = "8472507280";
const EMAIL_CALL = "info@advancecollision.com";

// ================================
// EXPORTS
// ================================

export {
  // Base
  APL_LINK,
  Website_URL,
  server_post_data,

  // Website APIs
  save_contact_estimate,
  get_blog_data_website,
  get_faq_by_page,
  get_home_page_data,
  blog_details_website,
  get_seo_data_website,
  get_seo_by_url,
  get_blog_data_website_by_url,
  get_website_contact_data,
  save_subs,

  // Admin APIs
  login_to_superadmin,
  get_dashboard_overview,
  save_update_blog,
  get_all_blogs,
  save_blog_keyword,
  get_all_blog_keyword,
  save_update_seo,
  get_all_seo,
  get_all_imagelink,
  save_update_imagelink,
  get_all_subscribe,
  save_subscribe,
  save_update_staff,
  get_all_staff,
  save_update_StaffRights,
  get_all_staffRights,
  action_update_staff_right,
  get_all_designation,
  save_update_designtion,
  save_contact_admin,
  save_update_testimonials,
  get_all_testimonials,
  delete_testimonials,
  save_update_WebsiteManagement,
  delete_website_master_data,
  save_update_blogfaq,
  get_all_WebsiteManagement,
  get_all_blogfaq,
  get_all_contact,
  save_update_blog_category,
  get_all_blog_category,
  delete_blog_category,
  toggle_blog_category,
  get_service_gallery_admin,
    save_update_service_gallery,
    delete_service_gallery,
  // Static
  MOBILE_NO,
  MOBILE_NO_CALL,
  EMAIL_CALL,
};
